import { Component } from '@angular/core';

@Component({
  selector: 'app-email-success-popup',
  standalone: true,
  imports: [],
  templateUrl: './email-success-popup.component.html',
  styleUrl: './email-success-popup.component.scss'
})
export class EmailSuccessPopupComponent {

}
